/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState} from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_REQUEST, API_POST, API_SERVER, API_SCT } from '../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import axios from 'axios'
import {reactLocalStorage} from 'reactjs-localstorage';
import {decode} from 'html-entities'
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

import {random_character} from '../../functions'

const Screen = ({loading, error, progress}) => {

    /*--------------------------------------------------------------
    [Storage]
    ----------------------------------------------------------------*/
    let STORAGE_TOKEN = reactLocalStorage.get('@token');

    let STORAGE_USER_STRINGIFY = reactLocalStorage.get('@user');

	let STORAGE_USER;

	if(STORAGE_USER_STRINGIFY){
		STORAGE_USER = JSON.parse(STORAGE_USER_STRINGIFY)
	}
    /*--------------------------------------------------------------
    [End Storage]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [State]
    ----------------------------------------------------------------*/
    const [refresh, set_refresh] = useState(null);
    const [data, set_data] = useState(null);
    const [pagination_active, set_pagination_active] = useState(1);
    const [element, set_element] = useState(null);
    const [level, set_level] = useState(null);
    const [name, set_name] = useState('');
    const [search, set_search] = useState('');

    const [file, set_file] = useState(null);
    /*--------------------------------------------------------------
    [End State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [API]
    ----------------------------------------------------------------*/

    const _read = (pages) => {

		let offsetSync;

        if(pages === 1){
            
            offsetSync = 0;    
        
        }else{

            offsetSync = pages ? (20 * pages) - 20 : 0
        
        }
        
        loading(true);

        API_GET_REQUEST('source__________?action=read'
            + '&limit=20'
            + '&offset=' + offsetSync
        , 
		).then((response) => {
            if(response.data.result == 'success'){
                console.log(JSON.stringify(response.data.data, undefined, 2))
                set_data(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console.log('catch : ', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _delete = (id, file) => {

        console.log('id', id)
        console.log('file', file)

        if(loading === true){
            return
        }

		loading(true);

		API_GET_REQUEST('source__________?action=delete'
			+ '&id=' + id
            + '&file=' + file
        , 
		).then((response) => {
            if(response.data.result == 'success'){
                // console.log(JSON.stringify(response.data, undefined, 2))
                set_refresh(random_character(16))
                error(response.data.title)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
			console.log(e)
			error(e.message);
		})
		.finally(() => {
			loading(false);
		})

	}

    const _add_source = () => {

        if(loading === true){
            return
        }

        loading(true);

        var data = new FormData();
        data.append("sct", API_SCT);
        data.append("key", STORAGE_USER[0].id_key);
        data.append("name", name);
        data.append("level", level);
        data.append("path", random_character(24));

        file.map((item) => (
            data.append("file", item)
        ))

        var config = {
            method: 'post',
            url: API_SERVER + "/api/v1.0/source/insert__________",
            headers: { 
                'Authorization': `Bearer ${STORAGE_TOKEN}`,
            },
            data : data,
            onUploadProgress: progressEvent => {
                console.log('loaded : ', progressEvent.loaded)
                console.log('total : ', progressEvent.total)
                progress(parseInt(Math.round((progressEvent.loaded/progressEvent.total) * 100)))
            }
        };

        axios(config)
        .then((response) => {
            if(response.data.result === 'success'){
                console.log(JSON.stringify(response.data));
                set_name('')
                set_level(null)
                set_file(null)
                set_refresh(random_character(16))
                error(response.data.title)
            }else if(response.data.error){
                error(response.data.error)
            }
        })
        .catch((e) => {
            console.log('catch : ', e)
            error(e.message)
        })
        .finally(() => {
			loading(false);
		})

    }

    const _search = () => {
        
        if(search.length > 3){
    
            API_GET_REQUEST('source__________?action=search'
                + '&search=' + search
            , 
            ).then((response) => {
                if(response.data.result == 'success'){
                    // console.log(JSON.stringify(response.data.data.list, undefined, 2))
                    set_data(response.data.data)
                    error('')
                }else if(response.data.error){
                    error(response.data.error);
                    set_data(null)
                }
            })
            .catch((e) => {
                console.log('catch : ', e)
                error(e.message)
            }).finally(() => {
                loading(false)
            })

        }

    }

    const _files = (event) => {

        if(!event){
            return error('Terjadi Kesalahan')
        }
        
        if(event){
            if(!event.target.files[0]){
                return error('File Dibatalkan')
            }
            
            if(event.target.files[0].size > 2048000){
                return error('Ukuran File maxsimal 2MB')
            }else{
                error('')
            }
        }

        let foo = event.target.files[0]; 

        set_file([foo]);

	};

    const _copy_text = (index) => {
        /* Get the text field */
        var copyText = document.getElementById(`copy_text_${index}`);

        // console.log('copy text', copyText.value)
      
        // /* Select the text field */
        copyText.select();
        copyText.setSelectionRange(0, 99999); /* For mobile devices */
      
        // /* Copy the text inside the text field */
        document.execCommand("copy");
      
        // /* Alert the copied text */
        // alert("Copied the text: " + copyText.value);
    }

    /*--------------------------------------------------------------
    [useEffect]
    ----------------------------------------------------------------*/
    useEffect(() => {

        if(search.length > 0){
            _search()
        }else{
            _read()
        }

    }, [refresh, search])
    /*--------------------------------------------------------------
    [End useEffect]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Render]
    ----------------------------------------------------------------*/
    return (
        <>
            <div>
                <div className="_row _center_align">
                    <div className="_column">
                        <h1 style={{marginBottom: 30}}><span style={{color: '#118ab2'}}>e-</span>Source</h1>
                    </div>
                </div>
                <div className="_row _center_align _push_b_s">
                    <div className="_column">
                        <div className="_row _center_align">
                            <ion-icon name="leaf-outline" style={{fontSize: 20}}></ion-icon>
                            <p className="_push_l_m">Semua Data Source Utama</p>
                        </div>
                    </div>
                    <div onClick={() => {
                        if(element === 'add_source'){
                            set_element(null)
                        }else{
                            set_element('add_source')
                        }
                    }} className="_btn _cursor_pointer">
                        Tambah
                    </div>
                </div>
                {
                    element === 'add_source' &&
                    <>
                        <div className="_relative _push_b_m">
                            <p style={{color: '#888', fontSize: 13}}>
                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                Name
                            </p>
                            <div className="_e_input">
                                <input 
                                    placeholder="" 
                                    onChange={e => set_name(e.target.value)}
                                    value={name}
                                />
                            </div>
                        </div>
                        <div className="_relative _push_b_m">
                            <p style={{color: '#888', fontSize: 13}}>
                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                Level
                            </p>
                            <div className="_e_input">
                                <input
                                    disabled="true" 
                                    placeholder="" 
                                    value={level}
                                />
                            </div>
                        </div>
                        <div className="_row _center_align">
                            <div className="_push_r_m _btn _cursor_pointer" onClick={() => set_level('image')}>
                                image
                            </div>
                            <div className="_push_r_m _btn _cursor_pointer" onClick={() => set_level('file')}>
                                file
                            </div>
                        </div>
                        <div className="_row _center_align _push_b_m">
                            <div className="_column">
                                <div className="_bb-input" style={{paddingBottom: 10, paddingTop: 10}}>
                                    
                                    <input
                                        className="custom-file-input" 
                                        type="file"
                                        name="file"
                                        placeholder=""
                                        onChange={_files}
                                    />

                                </div>
                            </div>
                            <span className="_btn _cursor_pointer" style={{height: 40}} onClick={() => {
                                if(level === null){
                                    error('Level harus dipilih')
                                }else if(file === null){
                                    error('File harus dipilih')
                                }else{
                                    _add_source()
                                }
                            }}>
                                Simpan
                            </span>
                        </div>
                    </>
                }

                <div className="_bb_search" style={{backgroundColor: 'transparent', border: 'none'}}>
                    <div className="_row _center_align">
                        <ion-icon name="search-outline" style={{fontSize: 20}}></ion-icon>
                        <div className="_column">
                            <input 
                                placeholder="Cari File" 
                                onChange={e => set_search(e.target.value)}
                                value={search}
                            />
                        </div>
                    </div>
                </div>

                <div style={{borderBottomWidth: 1, borderBottomColor: '#eee', borderBottomStyle: 'solid'}}></div>
                {
                    data && data.list.map((item, index) => (
                        <div key={index} className="_row _center_align _hover_backup_block" style={{cursor: 'default'}}>
                            <div onClick={() => _delete(item.id, item.file)} style={{marginRight: 16, cursor: 'pointer'}}>
                                <ion-icon name="trash-outline" style={{fontSize: 18}}></ion-icon>
                            </div>
                            <div className="_push_r_m">
                                {
                                    item.level === 'image' ?
                                        <ion-icon style={{fontSize: 18}} name="image-outline"></ion-icon>
                                    : item.level === 'file' ?
                                        <ion-icon style={{fontSize: 18}} name="document-outline"></ion-icon>
                                    : null
                                }
                            </div>
                            <div className="_push_r_d" style={{width: 100}}>
                                <p className="_text_overflow">{item.name}</p>
                            </div>
                            <div onClick={() => _copy_text(index)} className="_column _push_r_s">
                                <input
                                    style={{width: '100%'}}
                                    type="text"  
                                    id={`copy_text_${index}`} 
                                    value={API_SERVER + '/' + item.path + '/' + item.file}/>
                            </div>
                            {/* <div onClick={() => _download(overlay, item)}>
                                <ion-icon name="cloud-download-outline" style={{fontSize: 18}}></ion-icon>
                            </div> */}
                        </div>
                    ))
                }
                <div className="_container">
                    <div className="_lily_pad_h_d">
                        <div className="__pagination">
                            {
                                data&&data.pages.map((item, index) => {
                                    if(data.pages.length > 1){
                                        return (

                                            <div 
                                                key={index} 
                                                className="__item"
                                                style={{backgroundColor: pagination_active === index + 1 ? '#eee' : '#fff'}}
                                                onClick={() => {
                                                    _read(index + 1);
                                                    set_pagination_active(index + 1)
                                                }}
                                            >
                                                <div className="_position_middle">
                                                    {item}
                                                </div>
                                            </div>
                                            
                                        )
                                    }
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
    /*--------------------------------------------------------------
    [End Render]
    ----------------------------------------------------------------*/

}

export default Screen;